module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-steps-outer"
  }, [_c('div', {
    staticClass: "backer clearfix"
  }, [_vm._l((_vm.fields), function(field, i) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-3"
    }, [_c('label', {
      staticClass: "form-label",
      attrs: {
        "for": 'profile-' + field.label
      }
    }, [_c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(i + 1))]), _vm._v(" " + _vm._s(field.label))]), _vm._v(" "), _c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "disabled": "",
        "type": "text",
        "id": 'profile-' + field.label
      },
      domProps: {
        "value": _vm.display[field.vModel]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon",
      on: {
        "click": function($event) {
          return _vm.searchProfiles(field.profileCode, field.vModel)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    class: [_vm.valid ? '' : 'disabled', 'btn btn-primary sq fw-merge'],
    on: {
      "click": _vm.merge
    }
  }, [_vm._v("\n          Merge\n        ")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "merge-selector"
  }, [_c('blockquote', [_vm._v("Select Merge Type")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mergeType),
      expression: "mergeType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mergeType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "fcl"
    }
  }, [_vm._v("Ocean FCL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lcl"
    }
  }, [_vm._v("Ocean LCL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "auto"
    }
  }, [_vm._v("Ocean Auto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "air"
    }
  }, [_vm._v("Air")])])])]), _vm._v(" "), _c('div', {
    staticClass: "merge-stats clearfix"
  }, [_c('div', {
    staticClass: "shadow clearfix pad-15"
  }, [_c('hr', {
    staticClass: "hr-text",
    attrs: {
      "data-content": "Your Tariff Overview"
    }
  }), _vm._v(" "), _c('vue-table', {
    attrs: {
      "showEdit": true,
      "showDelete": true,
      "tableData": _vm.tableData,
      "tableTitle": "Recently Merged Tariffs",
      "fields": [{
          header: 'Name',
          prop: 'name'
        },
        {
          header: 'Type',
          prop: function (item) { return item.lookupType !== null ? item.lookupType.name : ''; }
        },
        {
          header: 'Agent',
          prop: function (item) { return item.owner ? item.owner.name : ''; }
        }
      ]
    },
    on: {
      "table-delete-request": _vm.deleteEntity,
      "table-edit-request": _vm.handleEdit
    }
  }), _vm._v(" "), _c('info-widget', {
    staticClass: "col-xs-12 col-sm-6 wid",
    attrs: {
      "stats": {
        title: 'Profiles',
        stat: _vm.stats.profiles
      },
      "backgroundColor": "#00beee",
      "color": "#fff",
      "animate": "",
      "logo": "fa fa-globe"
    }
  }), _vm._v(" "), _c('info-widget', {
    staticClass: "col-xs-12 col-sm-6 wid",
    attrs: {
      "stats": {
        title: 'Tariffs',
        stat: _vm.stats.tariffs
      },
      "backgroundColor": "#02a85c",
      "logo": "fa fa-map-marker",
      "color": "#fff",
      "animate": ""
    }
  }), _vm._v(" "), _c('info-widget', {
    staticClass: "col-xs-12 col-sm-6 wid",
    attrs: {
      "stats": {
        title: 'Lines',
        stat: _vm.stats.lines
      },
      "backgroundColor": "#f39c11",
      "logo": "fa fa-industry",
      "color": "#fff",
      "animate": ""
    }
  }), _vm._v(" "), _c('info-widget', {
    staticClass: "col-xs-12 col-sm-6 wid",
    attrs: {
      "stats": {
        title: 'Accessorials',
        stat: _vm.stats.accessorials
      },
      "backgroundColor": "#f56854",
      "logo": "fa fa-user",
      "color": "#fff",
      "animate": ""
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f0ffa7b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tariffmerge/components/TariffMerge.vue
// module id = 2242
// module chunks = 1